export const ENTITY_MODAL_TYPES = {
  task: {
    label: 'common.type_task',
    desc: 'entity.type_task_desc',
    accent: '#3b82f6',
    accentSoft: 'rgba(59,130,246,0.08)',
    accentBorder: 'rgba(59,130,246,0.18)',
  },
  note: {
    label: 'common.type_note',
    desc: 'entity.type_note_desc',
    accent: '#22c55e',
    accentSoft: 'rgba(34,197,94,0.08)',
    accentBorder: 'rgba(34,197,94,0.18)',
  },
  objective: {
    label: 'common.type_goal',
    desc: 'entity.type_goal_desc',
    accent: '#a855f7',
    accentSoft: 'rgba(168,85,247,0.08)',
    accentBorder: 'rgba(168,85,247,0.18)',
  },
  event: {
    label: 'common.type_event',
    desc: 'entity.type_event_desc',
    accent: '#f59e0b',
    accentSoft: 'rgba(245,158,11,0.08)',
    accentBorder: 'rgba(245,158,11,0.18)',
  },
  contact: {
    label: 'common.type_contact',
    desc: 'entity.type_contact_desc',
    accent: '#8b5cf6',
    accentSoft: 'rgba(139,92,246,0.08)',
    accentBorder: 'rgba(139,92,246,0.18)',
  },
};

export type ModalEntityKey = keyof typeof ENTITY_MODAL_TYPES;

export function entityTypeToModalKey(type: string): ModalEntityKey {
  if (type === 'goal') return 'objective';
  return type as ModalEntityKey;
}

export function modalKeyToEntityType(key: ModalEntityKey): string {
  if (key === 'objective') return 'goal';
  return key;
}
